import {
  FLOATING_TOOL_TEE_MOVED,
  FLOATING_TOOL_TEE_OPEN,
  FLOATING_TOOL_TEE_CLOSE,
  IS_DIRTY, CLOSE_MANIFOLD_ENTRY
} from "../lib/types";

export const floatingToolTeeMoved = ( x, y ) => dispatch => {

  dispatch({
    type: FLOATING_TOOL_TEE_MOVED,
    payload: { x, y }
  });
};

export const floatingToolInsertaTeeOpen = ( row, col, accessory ) => dispatch => {
  dispatch({
    type: FLOATING_TOOL_TEE_OPEN,
    payload: {
      row,
      col,
      accessory
    }
  });
  dispatch({
    type: CLOSE_MANIFOLD_ENTRY
  });
  dispatch({
    type: IS_DIRTY,
    payload: true
  });

};

export const floatingToolInsertaTeeClose = () => dispatch => {
  dispatch({
    type: FLOATING_TOOL_TEE_CLOSE
  });
};



// WEBPACK FOOTER //
// ./src/actions/floating-tool-inserta-tee-actions.js